<template>
  <vs-popup
    :title="'Edit events for section: ' + (section ? section.name : '')"
    @close="handlePopupClose"
    :active.sync="showThisPopup"
    class="edit-events-popup"
  >
    <div class="text-center p-16" v-if="isLoadingEvents">
      <p class="opacity-60">Finding events</p>
      <span class="flex h-12 w-12 mx-auto mt-5">
        <span
          class="
            animate-ping
            absolute
            inline-flex
            h-12
            w-12
            rounded-full
            bg-primary
            opacity-75
          "
        ></span>
        <span
          class="relative inline-flex rounded-full h-12 w-12 bg-primary"
        ></span>
      </span>
    </div>
    <div v-else class="p-4">
      <div v-if="events.length > 0">
        <div
          v-for="(event, index) in events"
          :key="index"
          class="event-border rounded p-4 mb-2"
        >
          <div v-if="event.isEditing">
            <vs-row vs-w="12">
              <vs-col vs-w="12">
                <vs-input
                  class="inputx"
                  label="Event name"
                  placeholder="Event name"
                  v-model="event.eventName"
                />
              </vs-col>
            </vs-row>

            <vs-row vs-w="12" class="mt-2">
              <vs-col vs-w="12">
                <vs-input
                  class="inputx"
                  label="Event description"
                  placeholder="Describe the event"
                  v-model="event.description"
                />
              </vs-col>
            </vs-row>

            <vs-row vs-w="12" class="mt-2">
              <vs-col vs-w="12">
                <vs-input
                  class="inputx"
                  label="Event image"
                  placeholder="Image url"
                  v-model="event.imageLink"
                />
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="mt-2">
              <vs-col vs-w="12">
                <label class="vs-input--label">Event start</label>
                <flat-pickr
                  :config="datePickerConfig"
                  v-model="event.eventStart"
                  placeholder="Choose start date and time"
                  style="width: 200px"
                  class="p-3 s-inputx vs-input--input flex"
                />
              </vs-col>
            </vs-row>
            <vs-row vs-w="12" class="mt-2">
              <vs-col vs-w="12">
                <label class="vs-input--label">Event end</label>
                <flat-pickr
                  :config="datePickerConfig"
                  v-model="event.eventEnd"
                  placeholder="Choose end date and time"
                  style="width: 200px"
                  class="p-3 s-inputx vs-input--input flex"
                />
              </vs-col>
            </vs-row>

            <vs-row vs-w="12" class="mt-2">
              <vs-col vs-w="12">
                <vs-button
                  :disabled="!isValid(event)"
                  class="mt-2 whitespace-nowrap"
                  @click="saveEvent(event)"
                >
                  Save
                </vs-button>
              </vs-col>
            </vs-row>
          </div>
          <div v-else>
            <h6>{{ event.eventName }}</h6>
            <p class="text-grey">
              <small
                >{{ formattedDate(event.eventStart) }} -
                {{ formattedDate(event.eventEnd) }}</small
              >
            </p>
            <p class="mt-1">{{ event.description }}</p>
            <div class="flex mt-2">
              <vs-button
                size="small"
                class="mr-1 whitespace-nowrap"
                @click="toggleEdit(event)"
                :disabled="
                  !hasPermissionForActiveVenue(
                    'vp.vp.booking.editevents'
                  )
                "
              >
                Edit
              </vs-button>
              <vs-button
                size="small"
                type="border"
                class="whitespace-nowrap"
                @click="deleteEvent(event)"
                :disabled="
                  !hasPermissionForActiveVenue(
                    'vp.vp.booking.editevents'
                  )
                "
              >
                Delete
              </vs-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p>No events for this section</p>
      </div>
      <vs-button
        class="mt-2 whitespace-nowrap"
        type="border"
        @click="addNewEvent()"
        :disabled="
          !hasPermissionForActiveVenue(
            'vp.vp.booking.editevents'
          )
        "
      >
        Add new event
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>
import * as _ from "lodash";
import Vue from "vue";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";

export default {
  props: {
    setup: {
      type: Object,
    },
  },
  components: {
    flatPickr,
  },
  data() {
    return {
      section: undefined,
      venueDetailsId: "",
      venueSetupId: "",
      showThisPopup: false,
      events: undefined,
      isLoadingEvents: true,
      datePickerConfig: {
        enableTime: true, // Set to true for time again
        enableSeconds: false,
        noCalendar: false,
        time_24hr: true,
        dateFormat: "Y-m-d H:i", // "d-m-Y H:i" for time 2021-11-19T19:00:00Z
      },
    };
  },
  computed: {
    validForm() {
      return (
        !!this.clonedSection &&
        !!this.clonedSection.name &&
        !!this.clonedSection.name.trim() &&
        this.policiesValid
      );
    },
    isDirty() {
      return !_.isEqual(this.section, this.clonedSection);
    },
    policiesValid() {
      return (
        !!this.clonedSection &&
        this.clonedSection.venuePolicies.every((p) => p.isValid())
      );
    },
  },
  methods: {
    async show(venueDetailsId, venueSetupId, section) {
      this.section = section;
      this.venueDetailsId = venueDetailsId;
      this.venueSetupId = venueSetupId;
      this.showThisPopup = true;
      this.loadEvents();
    },
    async loadEvents() {
      this.isLoadingEvents = true;
      var result = await this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.GetEvents,
        this.venueDetailsId
      );
      this.events = result.filter(
        (e) => e.venueSectionId.id === this.section.id
      );
      this.events.forEach((event) => {
        Vue.set(event, "isEditing", false);
      });
      this.isLoadingEvents = false;
    },
    addNewEvent() {
      this.events.push({
        venueDetailsId: {
          id: this.venueDetailsId,
        },

        venueSetupId: {
          id: this.venueSetupId,
        },
        venueSectionId: {
          id: this.section.id,
        },
        eventName: "",
        eventStart: null,
        eventEnd: null,
        description: "",
        imageLink: "",
        isEditing: true,
      });
    },
    toggleEdit(event) {
      Vue.set(event, "isEditing", true);
    },
    async saveEvent(event) {
      const start = moment(event.eventStart);
      event.eventStart = start.toJSON();

      const end = moment(event.eventEnd);
      event.eventEnd = end.toJSON();

      this.isLoadingEvents = true;
      var result = await this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.SaveEvent,
        event
      );

      this.isLoadingEvents = false;
      Vue.set(event, "isEditing", false);
    },
    async deleteEvent(event) {
      this.isLoadingEvents = true;
      var result = await this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.DeleteEvent,
        event.eventId.id
      );

      var index = this.events.indexOf(event);
      if (index >= 0) this.events.splice(index, 1);
      this.isLoadingEvents = false;
    },
    isValid(event) {
      if (event.eventName.length > 1 && event.eventStart && event.eventEnd) {
        const start = moment(event.eventStart);
        const end = moment(event.eventEnd);

        if (start < end) return true;
      }
      return false;
    },
    formattedDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    handlePopupClose() {
      this.clonedSection = undefined;
      this.showThisPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-events-popup::v-deep .vs-popup {
  width: 640px;

  .vs-popup--content {
    overflow: auto;

    .vs-tabs--content {
      max-height: calc(100vh - 225px);
      overflow: auto;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }

  .event-border {
    background: #f8f8f8;
  }
}
</style>
